import { format } from 'date-fns'

export const formatDateOfBirth = (date: Date) => format(date, 'yyyy-MM-dd')
